// extracted by mini-css-extract-plugin
module.exports = {"label":"Radio_label__2JhcT","input":"Radio_input__2KeGz","radioButton":"Radio_radioButton__3iUs1"};